<dialogContent>
  <div class="fx-layout-column">
    <mat-label>{{ data.label | transloco }}:</mat-label>
    <div class="fx-flex fx-layout-column rule-container">
      <div class="fx-layout-row">
        <mat-form-field class="fx-flex">
          <textarea
            #rule
            cdkTextareaAutosize
            matInput
            rows="1"
            [formControl]="ruleCopy"
            [matAutocomplete]="auto"
            (keyup)="getSuggestions($event, rule)"></textarea>
          @if (ruleCopy?.errors?.rule) {
            <mat-hint>{{ ruleCopy.errors?.rule | json }}</mat-hint>
          }
        </mat-form-field>

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
          @for (suggestion of autoCompleteResponse.suggestions; track suggestion) {
            <mat-option [value]="suggestion.variable">
              {{ suggestion.variable }} {{ suggestion.variable === suggestion.info ? '' : ' - ' + suggestion.info }}
            </mat-option>
          }
        </mat-autocomplete>

        <button color="accent" type="icon" (click)="openHelpDialog()">
          <mat-icon [icon]="'circle-help'" [iconSize]="24" />
        </button>
      </div>

      <div class="rule">
        @if (ruleCopy | prettifyRule: publishedComponents | async; as r) {
          <app-prettified-rule class="fx-layout" [prettified]="r.prettified" />
        }
      </div>
    </div>
  </div>
</dialogContent>

<dialogActions class="fx-layout fx-layout-align-end-center">
  <button ttButton>{{ 'Close' | transloco }}</button>
  <button color="accent" id="use-rule-button" mat-raised-button [disabled]="ruleCopy.errors" (click)="onSave()">
    {{ 'Use' | transloco }}
  </button>
</dialogActions>
